module.exports = __webpack_public_path__ + "static/media/success.a9fd55b1.png";